import { render, staticRenderFns } from "./CommunicationLog.vue?vue&type=template&id=e91e0c10&scoped=true&"
import script from "./CommunicationLog.vue?vue&type=script&lang=js&"
export * from "./CommunicationLog.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationLog.vue?vue&type=style&index=0&id=e91e0c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91e0c10",
  null
  
)

export default component.exports